import { defineModel, serializable } from '../model'

class Members {
    @serializable()
    items: ApiModel<'MemberData'>[]

    @serializable()
    limit: number

    @serializable()
    offset: number

    @serializable()
    totalItems: number
}

export default defineModel(Members)
